import { render, staticRenderFns } from "./TablaPlanes.vue?vue&type=template&id=50586fe4"
import script from "./TablaPlanes.vue?vue&type=script&lang=js"
export * from "./TablaPlanes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports